import { useEffect, useState, useRef } from "react";
import { Header } from "../../../components/Header";
import { HeaderCategories } from "../../../components/HeaderCategories";
import { Menu } from "../../../components/Menu";
import { PDVItem } from "../../../components/PDVItem";
import {
  useParams,
  useSearchParams,
  useLocation,
  useNavigate,
} from "react-router-dom";

import { useAppConfig } from "../../../hooks/useAppConfig";
import { ConfigType } from "../../../contexts/AppConfigContext";
import { Loading } from "../../../components/Loading";
import "./index.css";
import { usePluginspace } from "../../../hooks/usePluginspace";
import { floatToPrice } from "../../../functions/price_functions";
import { useFilters } from "../../../hooks/useFilters";
import { SimpleCategoryType } from "../../../contexts/CategoryContext";
import { ProductFoodType } from "../../../contexts/ProductsContext";
import { useProduct } from "../../../hooks/useProduct";
import { useOrder } from "../../../hooks/useOrder";
import { useQuery } from "../../../hooks/useQuery";
import { useScroll } from "../../../hooks/useScroll";
import { ImageLazy } from "../../../components/ImageLazy";
import { isVisibleByHour } from "../../../utils/visibilityHour";
import { FoodAlertTags } from "../../../components/FoodAlertTags";

export function FoodProducts() {
  const navigate = useNavigate();
  const { pluginspace_id } = useParams();
  const [searchParams] = useSearchParams();
  const { categories } = useFilters();
  const { scrollYProduct, setScrollYProduct } = useScroll();
  const { getProductsFood, selectProductFood } = useProduct();
  const { getAppConfig } = useAppConfig();
  const { getVerifyShift, registerAccess } = usePluginspace();
  const [config, setConfig] = useState<ConfigType | void>();
  const [loading, setLoading] = useState(true);
  const [classifications, setClassifications] = useState<SimpleCategoryType[]>(
    []
  );
  const [products, setProducts] = useState<Array<ProductFoodType>>([]);
  const [data, setData] = useState<Array<ProductFoodType>>([]);
  const [validShift, setValidShift] = useState(false);
  const [nameSearch, setNameSearch] = useState("");
  const [scrolling, setScrolling] = useState(true);

  const [activeMenu, setActiveMenu] = useState(0);
  const [label, setLabel] = useState("");
  const [loadingHeader, setLoadingHeader] = useState(true);

  const [isDown, setIsDown] = useState(false);

  const query = useQuery();
  const orderContext = useOrder();

  const restoredRef = useRef(false);

  useEffect(() => {
    if (activeMenu) {
      localStorage.setItem("lastActiveClassification", activeMenu.toString());
    }
  }, [activeMenu]);

  useEffect(() => {
    if (
      activeMenu &&
      document.getElementById(`classification-menu-${activeMenu}`)
    ) {
      scrollToMenu(activeMenu);
    }
  }, [activeMenu]);

  async function createVendorCart() {
    if (
      query.get("vendor") !== undefined &&
      query.get("vendor") !== "" &&
      query.get("vendor") != null
    ) {
      // gerar um carrinho informando qual o vendedor

      const x = query.get("vendor");

      const vendedorCPF = atob(x!);

      orderContext.cpfVendorByLink(vendedorCPF);
      orderContext.setSellerCpfCnpj(vendedorCPF);
      orderContext.setShouldUpdadeCustomerCart(true);

      registerAccess(
        "food-products",
        vendedorCPF,
        undefined,
        window.location.pathname
      );
    } else {
      registerAccess("food-products");
    }
  }

  useEffect(() => {
    createVendorCart();
    setClassifications([]);
    setProducts([]);
    const fetchData = async () => {
      setLoading(true);
      setLoadingHeader(true);
      await getConfig();
      setLoadingHeader(false);
      await getProducts();
      setValidShift(await getVerifyShift());
      setLoading(false);
      scrollToBefore();
      getLabel();
      goToSubcategory();
      const lastActive = localStorage.getItem("lastActiveClassification");
      if (lastActive && !restoredRef.current) {
        setActiveMenu(Number(lastActive));
        setTimeout(() => {
          scrollToClassification(Number(lastActive));
          restoredRef.current = true;
        }, 50);
      }
      const lastScroll = localStorage.getItem("lastScrollYProduct");
      if (lastScroll) {
        setTimeout(() => {
          const divItem = document.getElementById("content-products");
          if (divItem) {
            divItem.scrollTop = Number(lastScroll);
          }
        }, 60);
      }
    };
    fetchData();
  }, []);

  async function saveInfoSellerLinkCart() {
    if (orderContext.shouldUpdadeCart) {
      const orderToStorage = Object.assign(orderContext);
      await orderToStorage.encryptOrderStorage(orderToStorage);
    }
  }

  useEffect(() => {
    saveInfoSellerLinkCart();
  }, [orderContext.shouldUpdadeCart]);

  useEffect(() => {
    filter();
    goToSubcategory();
  }, [searchParams]);

  async function getProducts() {
    try {
      const configProject: ConfigType | void = await getAppConfig();
      const newProducts = await getProductsFood(
        configProject && configProject.content.pdv.showOutStock ? true : false
      );
      await loadProduct(
        newProducts.filter(
          (prod: ProductFoodType) =>
            prod.variations && prod.variations.length > 0
        )
      );
      setData(newProducts);
    } catch (error) {
      console.log(error);
    }
  }

  const scrollToBefore = () => {
    if (scrollYProduct.id) {
      const divItem = document.getElementById(scrollYProduct.id);
      if (divItem) divItem.scrollTop = scrollYProduct.position;
    }
  };

  async function getConfig() {
    const conf = await getAppConfig();
    setConfig(conf);
    return conf;
  }

  function goTop() {
    const divItem = document.getElementById("content-products");
    if (divItem) {
      divItem.scroll({ behavior: "smooth", top: 0 });
    }
  }

  const scrollToClassification = (id: number) => {
    setScrolling(false);
    const element = document.getElementById(`classification-${id}`);
    if (element) {
      element.scrollIntoView({ block: "start", behavior: "smooth" });
      setActiveMenu(id);
      localStorage.setItem("lastActiveClassification", id.toString());
    }
    setTimeout(() => {
      setScrolling(true);
    }, 2000);
  };

  const scrollToMenu = (id: number) => {
    const element = document.getElementById(`classification-menu-${id}`);
    const elementFull = document.getElementById(`classification-menu`);
    if (element && elementFull) {
      elementFull.scroll({ left: element.offsetLeft - 20, behavior: "smooth" });
      setActiveMenu(id);
      localStorage.setItem("lastActiveClassification", id.toString());
    }
  };

  function getLabel() {
    setLabel("");
    const table_number = localStorage.getItem("table_number");
    const table_name = localStorage.getItem("table_name");
    const card_number = localStorage.getItem("card_number");
    const card_name = localStorage.getItem("card_name");
    const internal_number = localStorage.getItem("internal_number");
    const internal_name = localStorage.getItem("internal_name");
    const landmark = localStorage.getItem("landmark_synkar");
    const landmarkPluginbot = localStorage.getItem("landmark_pluginbot");
    const counter = localStorage.getItem("counter_number");
    if (counter) {
      setLabel(`BALCÃO`);
    }
    if (landmark) {
      const landmarkItem = JSON.parse(window.atob(landmark));
      setLabel(landmarkItem.landmark);
    }
    if (landmarkPluginbot) {
      const landmarkPluginbotItem = JSON.parse(window.atob(landmarkPluginbot))
      setLabel(landmarkPluginbotItem.landmark)
    }
    if (card_number) {
      setLabel(
        `${card_name ? window.atob(card_name) : "COMANDA"} ${window.atob(
          card_number
        )}`
      );
    }
    if (table_number && !card_number) {
      setLabel(
        `${table_name ? window.atob(table_name) : "MESA"} ${window.atob(
          table_number
        )}`
      );
    }
    if (internal_number) {
      setLabel(
        `${internal_name ? window.atob(internal_name) : "LOCAL"} ${window.atob(
          internal_number
        )}`
      );
    }
  }

  const goToSubcategory = () => {
    const subcategory = searchParams.get("subcategory");
    if (subcategory) {
      scrollToClassification(Number(subcategory));
    }
  };

  const loadProduct = async (dataInitial: ProductFoodType[]) => {
    let _classifications: SimpleCategoryType[] = [];
    let _products: ProductFoodType[] = [];
    let data: ProductFoodType[] = dataInitial.filter(
      (product: ProductFoodType) =>
        isVisibleByHour(product.initialHour, product.finalHour)
    );
    const searchName = searchParams.get("name");
    if (searchName !== null) {
      const nameDecoded = window.atob(searchName)
        ? window.atob(searchName).toLocaleLowerCase()
        : "";

      setNameSearch(nameDecoded);

      data = data.filter((c) => {
        return c.name.toLocaleLowerCase().includes(nameDecoded);
      });
    }
    data.map((product: ProductFoodType) => {
      if (
        product.type === "fractional" &&
        product.fractions &&
        product.fractions.length > 0
      ) {
        let newVariation: any = {};
        Object.assign(newVariation, product.variations[0]);
        if (
          product.typeFractional === "proportional" &&
          product.quantityFractional
        ) {
          let priceVariation = 0;
          let qtdFractional = 0;
          product.fractions
            .sort((a, b) =>
              a.variations[0].price > b.variations[0].price
                ? 1
                : b.variations[0].price > a.variations[0].price
                ? -1
                : 0
            )
            .forEach((fractional, index) => {
              if (
                product.quantityFractional &&
                index < product.quantityFractional
              ) {
                priceVariation += fractional.variations[0].price;
                qtdFractional++;
              }
            });
          newVariation.price = priceVariation / qtdFractional;
          product.variations[0] = newVariation;
        } else if (product.typeFractional === "biggest") {
          let priceVariation = 0;
          product.fractions
            .sort((a, b) =>
              a.variations[0].price > b.variations[0].price
                ? 1
                : b.variations[0].price > a.variations[0].price
                ? -1
                : 0
            )
            .forEach((fractional) => {
              if (fractional.variations[0].price > priceVariation)
                priceVariation = fractional.variations[0].price;
            });
          newVariation.price = priceVariation;
          product.variations[0] = newVariation;
        }
      }
    });
    data.map((product: ProductFoodType) => {
      if (
        product.variations[0] &&
        product.variations[0].price > 0 &&
        product.type !== "optional" &&
        ((product.type === "fractional" &&
          product.fractions &&
          product.fractions.length > 0) ||
          product.type !== "fractional")
      ) {
        if (
          categories.length === 0 ||
          categories.includes(`${product.classification.id}`)
        ) {
          if (
            _classifications.findIndex(
              (item) => item.id === product.classification.id
            ) === -1
          ) {
            if (
              isVisibleByHour(
                product.classification.initialHour,
                product.classification.finalHour
              )
            ) {
              _classifications.push(product.classification);
            }
          }
          let imgProduct = "";
          if (product && product.images && product.images.length > 0) {
            let imgFind = product.images[0];
            if (imgFind) {
              imgProduct =
                imgFind.path.split("://")[1] ===
                "s3.amazonaws.com/img.ninegrid.com"
                  ? imgFind.path + "/" + imgFind.imgsuffix
                  : imgFind.path;
            }
          }
          product.img = imgProduct;
          _products.push(product);
        }
      }
    });
    _classifications = _classifications.sort((a, b) => {
      if (a.order === b.order) {
        return a.name < b.name ? -1 : 1;
      } else {
        return a.order < b.order ? -1 : 1;
      }
    });

    _products = _products.sort((a, b) =>
      a.order > b.order ? 1 : b.order > a.order ? -1 : 0
    );

    const conf = await getConfig();
    if (
      conf &&
      conf.content &&
      conf.content.orderCategory &&
      conf.content.orderCategory === "order"
    ) {
      setClassifications(
        _classifications.sort((a, b) =>
          a.order > b.order ? 1 : b.order > a.order ? -1 : 0
        )
      );
    } else {
      setClassifications(
        _classifications.sort((a, b) =>
          a.name > b.name ? 1 : b.name > a.name ? -1 : 0
        )
      );
    }
    // Só seta o activeMenu para a primeira categoria se não houver valor salvo
    const lastActive = localStorage.getItem("lastActiveClassification");
    if (!lastActive && _classifications[0]) {
      setActiveMenu(_classifications[0].id);
    }
    setProducts(_products);
  };

  const filter = () => {
    const searchName = searchParams.get("name");
    if (searchName !== null) {
      const nameDecoded = window.atob(searchName)
        ? window.atob(searchName).toLocaleLowerCase()
        : "";

      setNameSearch(nameDecoded);

      const filtered = data.filter((c) => {
        return c.name.toLocaleLowerCase().includes(nameDecoded);
      });
      loadProduct(
        filtered.filter(
          (prod: ProductFoodType) =>
            prod.variations && prod.variations.length > 0
        )
      );
    }
  };

  const handleScroll = (event: React.UIEvent<HTMLDivElement, UIEvent>) => {
    const eventItem: any = event;

    if (eventItem.target.scrollTop > 0) setIsDown(true);
    else setIsDown(false);

    if (scrolling) {
      const positions = classifications.map((c) => {
        const elem = document.getElementById(`classification-${c.id}`);
        if (elem) {
          const rect = elem.getBoundingClientRect();
          return {
            id: c.id,
            position: rect.y,
          };
        }
      });
      const position = positions.find(
        (c) =>
          c &&
          c?.position > 120 &&
          c.position < event.currentTarget.offsetHeight / 2
      );
      setScrollYProduct({
        id: event.currentTarget.id,
        position: event.currentTarget.scrollTop,
      });
      if (position && position.id !== activeMenu) {
        scrollToMenu(position.id);
        // Salva também ao scroll manual
        localStorage.setItem(
          "lastActiveClassification",
          position.id.toString()
        );
      }
    }
    if (event.currentTarget.id === "content-products") {
      localStorage.setItem(
        "lastScrollYProduct",
        event.currentTarget.scrollTop.toString()
      );
    }
  };

  function imageStyle() {
    console.log(config?.content.pdv.typeImage);

    switch (config?.content.pdv.typeImage) {
      case "round":
        return "50%";
      case "rounded":
        return "25%";
      case "square":
        return "0%";
      default:
        return "50%";
    }
  }

  return (
    <div className="products">
      <div
        className="content-products"
        id="content-products"
        onScroll={handleScroll}
      >
        {!loadingHeader && (
          <Header
            background={
              config?.webappcolor.backgroundheader
                ? config?.webappcolor.backgroundheader
                : "#F5F5F5"
            }
            colorIcon={
              config?.webappcolor.iconsheader
                ? config.webappcolor.iconsheader
                : "#636363"
            }
            logo={config?.icon ? config.icon : ""}
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
              config?.content &&
              config?.content.pdv &&
              config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
        {loading ? (
          <div style={{ width: "100%", height: "calc(100vh)" }}>
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          </div>
        ) : (
          <>
            <div className="sub-header">
              {(label || !validShift) && (
                <div
                  className="products-label"
                  style={{
                    backgroundColor: config?.webappcolor.backgroundtitlebar
                      ? config.webappcolor.backgroundtitlebar
                      : "#000000",
                  }}
                >
                  <span
                    style={{
                      color: config?.webappcolor.fonttitlebar
                        ? config.webappcolor.fonttitlebar
                        : "#FFFFFF",
                    }}
                  >
                    {validShift ? label : "LOJA FECHADA"}
                  </span>
                </div>
              )}
              {nameSearch && (
                <div className="search-text-food">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="#37393D"
                    viewBox="0 0 512 512"
                    onClick={() => {
                      navigate(`/${pluginspace_id}/products?name=`);
                    }}
                  >
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z" />
                  </svg>
                  <p>
                    {products.length > 1
                      ? `Foram encontrados`
                      : `Foi encontrado`}{" "}
                    <b>
                      {products.length > 1
                        ? `${products.length} produtos`
                        : `${products.length} produto`}
                    </b>{" "}
                    para a pesquisa "<b>{nameSearch}</b>"
                  </p>
                </div>
              )}
              {classifications.length > 0 && (
                <div
                  id="classification-menu"
                  className="classification-menu"
                  style={{
                    height: config?.content.pdv.showCategoryImages ? "8em" : 40,
                  }}
                >
                  {classifications.map((classification, i) => (
                    <div
                      key={`classification-menu-${i}`}
                      id={`classification-menu-${classification.id}`}
                      className={
                        `${activeMenu}` === `${classification.id}`
                          ? "active"
                          : ""
                      }
                      onClick={() => scrollToClassification(classification.id)}
                      style={{
                        borderBottomColor: config?.webappcolor
                          .backgroundtitlebar
                          ? config.webappcolor.backgroundtitlebar
                          : "#000000",
                      }}
                    >
                      <div className="classification-content">
                        {config?.content.pdv.showCategoryImages &&
                          (classification.img &&
                          classification.img !==
                            "public/default/no-image.png" ? (
                            <div
                              className="classification-img"
                              style={{
                                backgroundImage: `url(${classification.img})`,
                              }}
                            />
                          ) : (
                            <div
                              className="classification-img"
                              style={{
                                backgroundImage: `url(https://s3.amazonaws.com/img.ninegrid.com/public/default/no-image.png)`,
                              }}
                            />
                          ))}
                        <span
                          style={{
                            color: config?.webappcolor.backgroundtitlebar
                              ? config.webappcolor.backgroundtitlebar
                              : "#000000",
                          }}
                        >
                          {classification.name}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div
              onClick={() => goTop()}
              className="pdv-arrow-top-food"
              style={
                isDown
                  ? {
                      visibility: "inherit",
                      border: `1px solid ${
                        config?.webappcolor.backgroundtitlebar
                          ? config.webappcolor.backgroundtitlebar
                          : "#EAEAEA"
                      }`,
                    }
                  : {
                      visibility: "hidden",
                    }
              }
            >
              <i
                style={{
                  color: `${
                    config?.webappcolor.backgroundtitlebar
                      ? config.webappcolor.backgroundtitlebar
                      : "#EAEAEA"
                  }`,
                }}
                className="fa fa-arrow-up"
              ></i>
            </div>

            <div
              className="classification-list"
              style={{
                paddingTop:
                  config?.content.pdv.showCategoryImages && products.length > 0
                    ? `${14 + (nameSearch ? 5 : 0)}em`
                    : `${7 + (nameSearch ? 5 : 0)}em`,
              }}
            >
              {classifications.length > 0 ? (
                classifications.map((classification, i) => (
                  <div
                    id={`classification-${classification.id}`}
                    key={`classification-list-item-${i}`}
                    className="classification-list-item"
                  >
                    <div
                      className="title"
                      style={{
                        borderBottomColor: config?.webappcolor
                          .backgroundtitlebar
                          ? config.webappcolor.backgroundtitlebar
                          : "#000000",
                      }}
                    >
                      <span
                        style={{
                          color: config?.webappcolor.backgroundtitlebar
                            ? config.webappcolor.backgroundtitlebar
                            : "#000000",
                        }}
                      >
                        {classification.name}
                      </span>
                    </div>
                    <div className="product-list">
                      {products
                        .filter(
                          (c) => c.classification.id === classification.id
                        )
                        .map((product, j) => (
                          <div
                            key={`product-list-item-${j}`}
                            className="product-list-item"
                            onClick={() => {
                              selectProductFood(product.id.toString());
                              navigate(
                                `/${pluginspace_id}/products/${product.id}`
                              );
                            }}
                          >
                            <div>
                              <div>
                                <div className="title">
                                  <span>{product.name}</span>
                                </div>
                                <FoodAlertTags tags={product.alertTags} />
                                <div className="description">
                                  <span>{product.description}</span>
                                </div>
                                <div className="price">
                                  <span>
                                    {product.variations &&
                                    product.variations.length > 0
                                      ? product.type === "fractional"
                                        ? `A partir de ${floatToPrice(
                                            product.variations[0].price
                                          )}`
                                        : floatToPrice(
                                            product.variations[0].price
                                          )
                                      : floatToPrice(0)}
                                  </span>
                                </div>
                              </div>
                              {product.img &&
                                !config?.content.pdv.noProductImages && (
                                  <div className="image">
                                    <ImageLazy
                                      image={product.img}
                                      name={product.name}
                                      classImage={`${
                                        config?.content.pdv.typeImage
                                          ? config?.content.pdv.typeImage ===
                                            "round"
                                            ? "image-50Rounded"
                                            : config?.content.pdv.typeImage ===
                                              "rounded"
                                            ? "image-25Rounded"
                                            : "image-0Rounded"
                                          : "image-50Rounded"
                                      }`}
                                      type="food"
                                    />
                                  </div>
                                )}
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                ))
              ) : (
                <div className="no-product">
                  <h2>
                    {searchParams.get("name")
                      ? "Não encontramos resultados para sua busca :("
                      : "Não há produtos cadastrados :("}
                  </h2>
                </div>
              )}
            </div>
          </>
        )}
        {!loadingHeader && (
          <Menu
            fontColor={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            activeFontColor={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#000"
            }
            backgroundMenu={
              config?.webappcolor.backgroundfooter
                ? config?.webappcolor.backgroundfooter
                : "#F5F5F5"
            }
            colorIcons={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            highlightColorIcons={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#636363"
            }
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
              config?.content &&
              config?.content.pdv &&
              config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
      </div>
    </div>
  );
}
